import { jwtDecode } from 'jwt-decode'
import { LOCALES } from '@/constants'
import TrackingService from '@/services/TrackingService'
import { useStore } from '@/store'

class AuthService {
  async authorise (app) {
    const store = useStore(app.$pinia)
    const response = await app.$api.auth.authorise()

    if (response?.success) {
      const data = this.decodeToken(response.token)

      const localeToConvert = LOCALES.find(loc => loc.platformCode === data.site_language)
      if (localeToConvert) data.site_language = localeToConvert.code

      store.$patch({
        user: data,
        token: response.token
      })

      await app.$i18n.setLocale(data.site_language)

      const redirectPath = localStorage.getItem('postLoginRedirect')

      if (redirectPath) {
        localStorage.removeItem('postLoginRedirect')
        navigateTo(redirectPath)
      }
      store.$patch({ ready: true })

      const trackingService = new TrackingService(store.config)
      trackingService.identifyUser(data)
      trackingService.setupPendo(data)
    }
  }

  decodeToken (token) {
    return jwtDecode(token)
  }

  async setupGuestUser (store, i18n) {
    store.$patch({ guest: true })

    const params = new URLSearchParams(window.location.search.split('?')[1])
    const langParam = params.get('language')
    if (langParam) {
      const language = LOCALES.find(l => l.rfc5646 === langParam)
      if (language) {
        await i18n.setLocale(language.code)
        store.$patch({ language: language.code })
      }
    }

    store.$patch({ ready: true })
  }
}

export default new AuthService()
